export default {
  'customDomains.title': 'Custom domains',
  'customDomains.subtitle': 'Connect a hostname you own to an AUTOMY resource.',
  'customDomains.add': 'Add custom domain',
  'customDomains.addShort': 'Add domain',
  'customDomains.add.submitting': 'Connecting domain...',
  'customDomains.field.hint':
    'Enter the hostname, for example portal.yourcompany.com or siteprueba.atmy.in.',
  'customDomains.search': 'Search domains',
  'customDomains.searchEmpty': 'No domains match your search.',
  'customDomains.empty.title': 'No custom domains',
  'customDomains.empty.description': 'Connect a domain that you own to access this company.',
  'customDomains.loadError': 'We could not load custom domains.',
  'customDomains.loading': 'Loading domains...',
  'customDomains.retryLoad': 'Try again',
  'customDomains.column.domain': 'Domain',
  'customDomains.column.usedBy': 'Used by',
  'customDomains.column.status': 'Status',
  'customDomains.usedBy.company': 'Company',
  'customDomains.usedBy.app': 'App',
  'customDomains.missingCompany': 'We could not identify the company for this session.',

  'customDomains.drawer.kicker': 'Custom domain',
  'customDomains.drawer.title': 'Custom domain',
  'customDomains.drawer.intro': 'Use your own domain to access this resource.',
  'customDomains.drawer.empty.title': 'No custom domain configured.',
  'customDomains.drawer.empty.description': 'Connect a domain that you own to {name}.',
  'customDomains.drawer.back': 'Back',
  'customDomains.drawer.close': 'Close',
  'customDomains.manage': 'Manage',
  'customDomains.field.domain': 'Domain',
  'customDomains.field.placeholder': 'clientes.acme.com',
  'customDomains.add.title': 'Connect domain',
  'customDomains.add.submit': 'Connect domain',
  'customDomains.managed.title': 'AUTOMY domain',
  'customDomains.managed.hint': 'Always available',
  'customDomains.managed.editSlug': 'Edit slug',
  'customDomains.section.custom': 'Custom domain',

  'customDomains.status.pending': 'Pending',
  'customDomains.status.pendingHint': 'The domain was added. Setup has not started.',
  'customDomains.status.configureDns': 'Configure DNS',
  'customDomains.status.configureDnsHint': 'Add the DNS records to continue.',
  'customDomains.status.provisioning': 'Provisioning',
  'customDomains.status.startedHint': 'Setup started. The provider has not been read yet.',
  'customDomains.status.settingUp': 'Provisioning',
  'customDomains.status.settingUpHint': 'AUTOMY is configuring the domain.',
  'customDomains.status.httpsHint': 'DNS was accepted. Configuring HTTPS.',
  'customDomains.status.retryScheduledHint': 'An automatic retry is scheduled. You can retry now too.',
  'customDomains.status.active': 'Active',
  'customDomains.status.activeHint': 'Your custom domain is connected and ready to use.',
  'customDomains.status.connectedHint': 'Connected. The site opens on this hostname when it is published.',
  'customDomains.status.disabled': 'Disabled',
  'customDomains.status.disabledHint': 'This domain is currently disabled.',
  'customDomains.status.error': 'Error',
  'customDomains.status.connectFailedHint': 'The domain could not be connected.',
  'customDomains.status.connectFailedSupportHint':
    'The domain could not be connected. Contact support.',
  'customDomains.status.actionRequired': 'Error',
  'customDomains.status.actionRequiredHint': 'The domain could not be connected.',
  'customDomains.status.setupIssue': 'Error',
  'customDomains.status.setupIssueHint': 'The domain could not be connected. Contact support.',
  'customDomains.status.removing': 'Removing',
  'customDomains.status.removingHint': 'This domain is being disconnected.',

  'customDomains.actions.setup': 'Set up domain',
  'customDomains.actions.enable': 'Enable',
  'customDomains.actions.check': 'Check now',
  'customDomains.actions.checking': 'Checking...',
  'customDomains.actions.viewDns': 'Configure DNS',
  'customDomains.actions.retry': 'Retry',
  'customDomains.actions.reviewDns': 'Review DNS',
  'customDomains.actions.disable': 'Disable',
  'customDomains.actions.remove': 'Remove domain',
  'customDomains.actions.refresh': 'Refresh DNS verification',
  'customDomains.actions.contactSupport': 'Contact support',

  'customDomains.verify.title': 'Waiting for verification',
  'customDomains.dns.title': 'Configure your DNS',
  'customDomains.dns.ownership': 'Verify ownership',
  'customDomains.dns.connect': 'Connect your domain',
  'customDomains.dns.type': 'Type',
  'customDomains.dns.name': 'Name',
  'customDomains.dns.value': 'Value',
  'customDomains.dns.copy': 'Copy',
  'customDomains.dns.copyAll': 'Copy all',
  'customDomains.dns.expires': 'Expires',
  'customDomains.dns.directCname':
    'The CNAME must point directly to the value shown. A chained CNAME will not work.',
  'customDomains.dns.propagation':
    'DNS changes can take some time to propagate. You can close this panel and return later.',
  'customDomains.dns.waiting': 'Setting up',
  'customDomains.dns.waitingHint':
    'Verification details are not ready yet. You can close this panel and return later.',

  'customDomains.confirm.disableTitle': 'Disable {hostname}?',
  'customDomains.confirm.disableBody':
    'This domain will stop opening the site. You can connect it again.',
  'customDomains.confirm.removeTitle': 'Remove {hostname}?',
  'customDomains.confirm.removeBody':
    'This domain will be removed. The hostname can be used again after it disappears from the list.',

  'customDomains.error.hostnameRequired': 'Enter a domain.',
  'customDomains.error.hostnameInvalid': 'Enter a valid domain.',
  'customDomains.error.hostnameTooLong': 'This domain is too long.',
  'customDomains.error.hostnameReserved': "This domain isn't available.",
  'customDomains.error.hostnameDuplicate': 'This domain is already being used in AUTOMY.',
  'customDomains.error.apexNotSupported':
    'Azure Front Door does not support root domains in this version.',
  'customDomains.error.targetNotFound': 'The custom domain target was not found.',
  'customDomains.error.targetCompanyMismatch':
    'The company target does not match the company in this session.',
  'customDomains.error.companyNotFound': 'The company does not exist or was deleted.',
  'customDomains.error.wildcardNotSupported': "Wildcard domains aren't supported.",
  'customDomains.error.targetNotSupported': "This resource can't use custom domains yet.",
  'customDomains.error.targetNotEligible': "This resource can't use custom domains.",
  'customDomains.error.providerNotEnabled':
    'The custom domain provider is not enabled for this domain.',
  'customDomains.error.destinationNotReady':
    "Custom domains aren't ready for this workspace yet. Contact support.",
  'customDomains.error.invalidState': "This action isn't available right now.",
  'customDomains.error.retryNotAllowed': "Retry isn't available in the current state.",
  'customDomains.error.refreshNotAllowed': "DNS verification can't be refreshed right now.",
  'customDomains.error.forbidden': "You don't have permission for this action.",
  'customDomains.error.notFound': 'This domain no longer exists.',
  'customDomains.error.generic': "This action isn't available right now.",
};
